var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftRightArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 9.79883H3.16016L5.18359 7.63867C5.42969 7.36523 5.42969 6.95508 5.15625 6.70898C4.88281 6.46289 4.47266 6.46289 4.22656 6.73633L1.16406 10.0176C0.917969 10.2637 0.917969 10.6738 1.16406 10.9199L4.22656 14.2012C4.36328 14.3379 4.52734 14.3926 4.71875 14.3926C4.85547 14.3926 5.01953 14.3379 5.15625 14.2285C5.42969 13.9824 5.42969 13.5723 5.18359 13.2988L3.16016 11.1113H14.3438C14.6992 11.1113 15 10.8379 15 10.4551C15 10.0996 14.6992 9.79883 14.3438 9.79883ZM1.65625 4.98633H12.8125L10.7891 7.17383C10.543 7.44727 10.543 7.85742 10.8164 8.10352C11.0898 8.34961 11.5 8.34961 11.7461 8.07617L14.8086 4.79492C15.0547 4.54883 15.0547 4.13867 14.8086 3.89258L11.7461 0.611328C11.6094 0.474609 11.4453 0.392578 11.2812 0.392578C11.1172 0.392578 10.9531 0.474609 10.8164 0.583984C10.543 0.830078 10.543 1.24023 10.7891 1.51367L12.8125 3.67383H1.65625C1.27344 3.67383 1 3.97461 1 4.33008C1 4.71289 1.27344 4.98633 1.65625 4.98633Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRightArrows);
export default __webpack_public_path__ + "static/media/left-right-arrows.f810a284.svg";
export { ForwardRef as ReactComponent };